import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import queryString from 'query-string';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { RestClient } from './api/RestClient';
import i18n from './i18n';

// Init rest client
RestClient.init(process.env.REACT_APP_API_BASE_URL, null);

try {
  const qsParsed = queryString.parse(window.location.search);
  if (qsParsed) {
    const lang = qsParsed.lang as string;
    console.log('Selected language', lang);
    if (lang && lang.trim().length === 2) {
      i18n.changeLanguage(lang.trim().toLowerCase());
    }
  }
} catch (err) {
  console.log('Read start param failed.', err);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <FluentProvider theme={webLightTheme}>
    <App />
  </FluentProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
